import React, { Component, useContext, useState, useEffect, Fragment } from "react";
import styled, { css } from "styled-components";
import Colorer from 'color';
import { ProductContext } from "../../context";
import { relative } from "path";
import { color } from "highcharts";
import { reduce } from "highcharts";
import Bg from "../Bg";
import { orders } from './orders';
import Tap from 'react-interactions';
import Popup from "../Popup";
import { Scrollbars } from 'react-custom-scrollbars';
import { eraseCookie } from '../store/Cookie';
import { Tabs } from './Tabs';
import { UserAccountOrders } from "./UserAccountOrders";
import { UserAccountSubscriptions } from "./UserAccountSubscriptions";
import { InputM, CssLabel } from '../uikit-b2c/InputM';
import { CssImage, CssPrice, CssPaper,
  CssH1,
  CssFormGroup,
  CssPopSection,
} from "./../uikit-b2c/uikit-b2c";
import { ContentBlock } from '../uikit-b2c/uikit-b2c';


import {
  Route,
  Switch,
  Link,
  useParams,
  withRouter,
} from "react-router-dom";
import { UserAccountRefunds, CssCols } from './UserAccountRefunds';
import { UserAccountPayment } from "./UserAccountPayment";

export const UserAccount = ({
  root = '/',
  fullscreen = false,
  page='orders',
  history,
  match,
  location,
  handleClose =()=>void(0),
}) => {

  const valueFromContext = useContext(ProductContext);



  let [state, setState] = useState('profile');

  useEffect(() => {
    if (match && match.params && match.params.id && match.params.id !== state) {
      setState(match.params.id)
    }
  },[match]);


  const handleUrl = (nw) => {
    if (nw) {
      history.push(`${root}${nw}`)
    } else {
        history.push(root)
    }
  };


    const tabsSettings = {
      tabs: [
        {
          label: <div className="">
            {valueFromContext && valueFromContext.user && <img
              src={valueFromContext.user["picture"]}
              data-radium="true"
              style={{
                borderRadius: "100%",
                width: 36,
                height: 36,
                marginRight: 13
              }}
            />}
            Profile
          </div>,
          value: 'profile',
          component: <UserAccountProfile/>,
        },
        {
          label: 'Orders',
          value: 'orders',
          component: <UserAccountOrders/>,
        },
        {
          label: 'Subscriptions',
          value: 'subscriptions',
          component: <UserAccountSubscriptions/>,
        },
        {
          label: 'Payment',
          value: 'payment',
          component: <UserAccountPayment/>,
        },
        {
          label: 'Notification',
          value: 'notification',
          component: <UserAccountNoti/>,
        },
        {
          label: 'My refunds (1)',
          value: 'refunds',
          component: <UserAccountRefunds/>,
        },
      ]
    }






    if (true || valueFromContext['user'] && state) {
      return (
        <Popup
          // theme={valueFromContext.getTheme()}
          title={()=>{return <Tabs
            root={root}
            theme={valueFromContext.getTheme()}
            active={state}
            handleTab={(nw)=>{
              handleUrl(nw)
              // setState(nw)
            }}
            {...tabsSettings}
          />}}
          sb={valueFromContext['sbShown']}
          // handleClose={()=>handleUrl()}
          handleClose={handleClose}
        >


          {state === 'profile' && <UserAccountProfile />}

          {state === 'orders' && <UserAccountOrders />}

          {state === 'subscriptions' && <UserAccountSubscriptions />}

          {state === 'payment' && <UserAccountPayment />}

          {state === 'notification' && <UserAccountNoti />}

          {state === 'refunds' && <UserAccountRefunds />}


      </Popup>
    )} else {
      return null
    }
  }





  export default withRouter(UserAccount)


export const UserAccountRefundsLine = ({
  theme,
  date,
  title,
  label,
  active,
  line,
}) => {
  return(

    <CssCols cols="2fr 1fr 8fr">

      <CssFormGroup indentation="lg">
        {date}
      </CssFormGroup>

      <CssRefTime0 >
        <CssRefTimeO active={active} theme={theme}/>
        <CssRefTimeLine line={line ? line : 'none'} theme={theme}/>
      </CssRefTime0>


      <CssFormGroup indentation="lg">
        <CssH1>{title}</CssH1>
        {label}
      </CssFormGroup>

    </CssCols>


  )
}






export const Ex_UserAccountNoti = () => {
  const valueFromContext = useContext(ProductContext);
  useEffect(() => {
    valueFromContext.setStateFrom('sbShown', false)
  }, [])
  return (
    <Popup
      theme={valueFromContext.getTheme()}
      title={()=>{return <CssH1>Notifications</CssH1>}}
      sb={false}
    >
      <UserAccountNoti />
    </Popup>
  )
}


export const Ex_UserAccountPurchases = ({
  fullscreen
}) => {


  const PurchasesMenu = ({}) => {
    const [state, setState] = useState('purchases');
    return (
      <React.Fragment>

    </React.Fragment>
    )
  }


  const valueFromContext = useContext(ProductContext);
  useEffect(() => {
    valueFromContext.setStateFrom('sbShown', false)
  }, [])

  return (
    <Popup
      fullscreen = {fullscreen}
      theme={valueFromContext.getTheme()}
      title={()=> <PurchasesMenu/>}
      sb={false}
    >
      <UserAccountOrders />
    </Popup>
  )
}





export const UserAccountNoti = () => {

  const valueFromContext = useContext(ProductContext);

  return (
    <React.Fragment>
      <CssFormGroup alignment="center">
      <CssPopSection theme={valueFromContext.getTheme()}>

        <CssFormGroup indentation="lg">
          <CssH1>Notification settings</CssH1>
        </CssFormGroup>

        <CssFormGroup indentation="lg">
          <MToggle
            active={true}
            title='Subscription renewal notification'
            description="Yo'll get an email reminder 3 days before the subscription renews"
          />
        </CssFormGroup>
        <CssFormGroup indentation="lg">
          <MToggle
            active={true}
            title='Successfull renewal notification'
            description="You'll receive an email after the subsctiption has been renewed"
          />
        </CssFormGroup>
        <CssFormGroup indentation="lg">
          <MToggle
            active={false}
            title='Failed renewal notification'
            description="You'll receive an email if the renewal is unsiccessfull"
          />
        </CssFormGroup>
        <CssFormGroup indentation="lg">
          <MToggle
            active={true}
            title='Subscription ended notification'
            description="You'll receive an email when the subscription is suspended"
          />
        </CssFormGroup>
      </CssPopSection>
      </CssFormGroup>
    </React.Fragment>)
}



const MToggle = ({
  active = false,
  title,
  description,
}) => {
  let [act, setAct] = useState(active);

  const valueFromContext = useContext(ProductContext);

  const CssToggH1 = styled.div`
    font-size: 1.4em;
    font-weight: bolder;
    margin-bottom: 4px;
    cursor: pointer;
    &:hover{
      opacity: 0.8
    }
  `

  return (
   <div style={{display: 'flex', opacity: act ? 1 : 0.8}}
    onClick={()=>{
      setAct(!act)
    }}
   >
     <MToggleSwitch
      active={act}
      colorToggle = {valueFromContext.getTheme('colorBg')}
      colorA = {valueFromContext.getTheme('colorAccent')}
      colorB = {Colorer(valueFromContext.getTheme('colorText')).alpha(0.5).string()}

     />
     <div className="">
        <CssToggH1>{title}</CssToggH1>
        <div style={{opacity: 0.6}}>{description}</div>
     </div>
   </div>
  )
}




export const MToggleSwitch = ({
  active = false,
  colorToggle = 'white',
  colorA = '#AAAAAA',
  colorB = '#00C77E'
}) => {
  return (
    <div style={{
      width: 32,
      height: 24,
      marginRight: 16
    }}>

{active && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16">
  <g id="toggle" transform="translate(0 0)">
    <rect width={24} height={16} rx={8} ry={8} fill={colorB}>
      <animate attributeName="fill" from={colorB} to={colorA} dur="0.4s" calcMode="linear" fill="freeze" begin="0s" restart="never" />
    </rect>
    <circle cx={8} cy={8} r="5.5" fill={colorToggle}>
      <animate attributeName="cx" d="dot" from={8} to={16} dur="0.3s" fill="freeze" begin="0s" restart="never" values="8; 17; 16" keyTimes="0; 0.5; 1" keySplines="0 0 1 1;
                  0.47 0 0.745 0.715;
                  0.39, 0.575, 0.565, 1;" />
    </circle>
    <circle cx={8} cy={8} r="5.5" style={{opacity: 0}} />
  </g>
</svg>}

{!active && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16">
  <g id="toggle" transform="translate(0 0)">
    <rect width={24} height={16} rx={8} ry={8} fill={colorA}>
      <animate attributeName="fill" from={colorA} to={colorB} dur="0.4s" calcMode="linear" fill="freeze" begin="0s" restart="never" />
    </rect>
    <circle cx={16} cy={8} r="5.5" fill={colorToggle}>
      <animate attributeName="cx" d="dot" from={16} to={8} dur="0.3s" fill="freeze" begin="0s" restart="never" values="16; 7; 8" keyTimes="0; 0.5; 1" keySplines="0 0 1 1;
                  0.47 0 0.745 0.715;
                  0.39, 0.575, 0.565, 1;" />
    </circle>
    <circle cx={8} cy={8} r="5.5" style={{opacity: 0}} />
  </g>
</svg>

}
    </div>
  )
}














export const UserAccountProfile = () => {

  const valueFromContext = useContext(ProductContext);
  let nameInput;


  const logOutHandler = () => {
    eraseCookie("xsolla_login_token", null);
    eraseCookie("xsolla_last_click_id", null);
    window.location.reload();
  }

  useEffect(() => {
    // nameInput.focus();
  }, [])


  const defUser = {
    email: "mikoza@gmail.com",
    exp: 1570856091,
    groups: Array(1),
    length: 1,
    __proto__: Array(0),
    iat: 1570769691,
    id: "1674060205943903",
    iss: "https://login.xsolla.com",
    name: "Carlos Jackson",
    picture: "https://platform-lookaside.fbsbx.com/platform/profilepic/?asid=1674060205943903&height=50&width=50&ext=1573361690&hash=AeQnGZTITvIjPdDB",
    provider: "facebook",
    // publisher_id: 15924,
    sub: "ea956a5a-29ec-11e9-bac8-42010aa80017",
    type: "social",
    xsolla_login_access_key: "cvhQfYADzuo-hfRSQbOYbB4qe21akl_zj3YVU4-6piI",
    xsolla_login_project_id: "b3632bfa-275e-11e9-9244-42010aa80004",
  }

  let user = valueFromContext.user || defUser;

  return (
    <React.Fragment>

      <CssFormGroup alignment="center">
            <CssPopSection theme={valueFromContext.getTheme()}>
              <CssHeader>
                <CssH1>User info</CssH1>
              </CssHeader>
              <CssSection>


                    <ContentBlock>
                      <CssLabel>Avatar</CssLabel>
                      <CssImage
                        style={{
                          backgroundImage: `url(${user["picture"]})`,
                          backgroundSize: 'cover',
                          height: '64px',
                          width: '64px',
                          zIndex: 10,
                          position: 'relative',
                        }}
                      />
                    </ContentBlock>



                    <CssFormGroup>
                      <InputM
                        label="Username"
                        ref={(input) => { nameInput = input; }}
                        handle={()=>void(0)}
                        value={user['userName']}/>
                    </CssFormGroup>

                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: '48% 48%',
                      gridColumnGap: '4%',
                    }}>
                      <CssFormGroup>
                        <InputM
                          label="First name"
                          value={user['name'].split(' ')[0]}/>
                      </CssFormGroup>

                      <CssFormGroup>
                        <InputM
                          label="Last name"
                          value={user['name'].split(' ')[1]}/>
                      </CssFormGroup>
                    </div>

                    <CssFormGroup>
                      <InputM
                        label="Birthday"
                      />
                    </CssFormGroup>



              </CssSection>
          </CssPopSection>
      </CssFormGroup>

      <CssFormGroup alignment="center">
        <CssPopSection theme= {valueFromContext.getTheme()}>
            <CssHeader>
              <CssH1>Security and privacy</CssH1>
            </CssHeader>
            <CssSection>

                <CssFormGroup>
                  <CssLabel>Password</CssLabel>
                  <InputM value="☠ ️☠️ ☠️ ☠️ ☠️"/>
                </CssFormGroup>

            </CssSection>
        </CssPopSection>
      </CssFormGroup>

      <CssFormGroup alignment="center">
        <CssPopSection theme= {valueFromContext.getTheme()}>

          <CssFormGroup>
            <CssHeader>
              <CssH1>Social Networks</CssH1>
            </CssHeader>
          </CssFormGroup>

            <CssSection>

              <CssFormGroup>

                <div style={{display: 'grid', width: '100%', gridColumnGap: '16px', gridRowGap: '16px', gridTemplateColumns: '1fr 1fr 1fr', gridTemplateRows: '80px'}}>
                  <CssLoginButton theme= {valueFromContext.getTheme()}>
                    Facebook
                    <Tap
                      scale
                      waves
                    />
                  </CssLoginButton>
                  <CssLoginButton theme= {valueFromContext.getTheme()}>
                    Twitter
                    <Tap
                      scale
                      waves
                    />
                  </CssLoginButton>
                  <CssLoginButton theme= {valueFromContext.getTheme()}>
                    Google
                    <Tap
                      scale
                      waves
                    />
                  </CssLoginButton>
                </div>

              </CssFormGroup>

            </CssSection>
        </CssPopSection>
      </CssFormGroup>

      <CssFormGroup alignment="center">
        <CssPopSection theme= {valueFromContext.getTheme()}>
            <CssSection>

              <CssFormGroup>
                 <CssLoginButton
                    onClick={logOutHandler}
                    theme={valueFromContext.getTheme()}
                  >
                    <span className="mr-10">
                      <i className="fas fa-sign-out-alt"></i> Log out
                    </span>
                    <Tap
                      scale
                      waves
                    />
                  </CssLoginButton>
              </CssFormGroup>

            </CssSection>
        </CssPopSection>
      </CssFormGroup>


    </React.Fragment>
  )
}





const CssConnector = styled.div`
    position: relative;
    background-color: transparent;
    border-radius: 6px;
    margin-right: 16px;
    background-size: 90%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    min-widthL: 100%;
    border: 1px solid ${({theme}) => Colorer(theme['colorBg']).alpha(0.8).string()};
`









export const CssActions = styled.div`
  border-top: 1px solid ${({theme}) => Colorer(theme['colorText']).alpha(0.2).string()};
  padding: 8px 0 0 0;
`;


const CssRefTime0 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const CssRefTimeO = styled.div`
  border: 1px solid ${({theme}) => Colorer(theme['colorText']).alpha(0.8).string()};
  background: ${({theme, active}) => active && Colorer(theme['colorText']).alpha(0.8).string()};
  border-radius:100px;
  width: 16px;
  height: 16px;
`;

const CssRefTimeLine = styled.div`
  border-left: 1px ${({line}) => !!line ? line : 'solid'} ${({theme}) => Colorer(theme['colorText']).alpha(0.2).string()};
  flex-grow:1;
`;



export const CssLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  opacity: 0.6;
`;
export const CssRight = styled.div`
  /* display: flex;
  flex-wrap: wrap; */
`;

export const CssOrderNum = styled.div`
  font-size: 0.9em;
`;



const CssHeader = styled.div`
  /* max-width: 180px; */
  line-height: 24px;
  padding-top: 4px;
  font-size: 11px;
  flex-grow: 1;
  line-height: normal;
  letter-spacing: -0.013em;
  font-weight: bold;
  /* text-transform: uppercase; */
`

const CssSection = styled.div`
  color: ${({theme}) => theme['colorText']};
  flex-grow: 1;
`

const CssLoginButton = styled.div`
  display:flex;
  flex-direction:row;
  font-size:0.8rem;
  line-height:2em;
  display:flex;
  flex-direction:column;
  align-items: center;
  justify-content:center;
  font-family: 'Roboto';
  color: ${({theme}) => theme.colorAccent};
  border: 1px solid ${({theme}) => theme.colorAccent};
  border-radius: 4px;
  padding: 0 0.6rem;
  cursor: pointer;
  /* border: 1px solid red; */
`
